// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}
th {
  vertical-align: top !important;
}
#mainDiv {
  display: block;
  max-height: 21rem;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}
#myTable {
  border-top: 0px none !important;
  border-bottom: 0px none !important;
  margin-bottom: 0px !important;
}
#myTable th {
  border-top: 0px none !important;
}
#alertdanger,
#alertdanger2,
#alertdanger3,
#alertsuccess {
  display: none;
  position: absolute;
  width: 98%;
  bottom: 2.5rem;
  text-align: center !important;

}
.alert {
  padding: 20px !important;   
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;;;;EAIE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,6BAA6B;;AAE/B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\nth {\n  vertical-align: top !important;\n}\n#mainDiv {\n  display: block;\n  max-height: 21rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-top: 1px solid lightgrey;\n  border-bottom: 1px solid lightgrey;\n}\n#myTable {\n  border-top: 0px none !important;\n  border-bottom: 0px none !important;\n  margin-bottom: 0px !important;\n}\n#myTable th {\n  border-top: 0px none !important;\n}\n#alertdanger,\n#alertdanger2,\n#alertdanger3,\n#alertsuccess {\n  display: none;\n  position: absolute;\n  width: 98%;\n  bottom: 2.5rem;\n  text-align: center !important;\n\n}\n.alert {\n  padding: 20px !important;   \n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
